import { Component, EventEmitter, Output } from '@angular/core';

import { ApiService } from '../../shared/api.service';

@Component({
    selector: 'aza-rws-profile-change-password',
    templateUrl: 'change-password.component.html',
    styleUrls: ['change-password.component.css']
})
export class ChangePasswordComponent {
    newPassword = '';
    confirmNewPassword = '';
    passwordChanged = false;
    @Output() closed = new EventEmitter<void>();

    constructor(private apiSvc: ApiService) {
    }

    async onConfirm(): Promise<void> {
        this.passwordChanged = false;
        await this.apiSvc.changeProfilePassword(this.newPassword);
        this.passwordChanged = true;
    }

    onClosed(): void {
        this.closed.emit();
    }
}
